export default __webpack_public_path__ + "static/media/page-4.f6a34c56.png";